module.exports = __webpack_public_path__ + "static/media/2-1.aba62317.png";